import { render, staticRenderFns } from "./cargoClause.vue?vue&type=template&id=338dd03e&"
import script from "./cargoClause.vue?vue&type=script&lang=js&"
export * from "./cargoClause.vue?vue&type=script&lang=js&"
import style0 from "./cargoClause.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cargoClause.vue"
export default component.exports